// extracted by mini-css-extract-plugin
module.exports = {"container":"AutocompleteCategories_container__3x6xb","result":"AutocompleteCategories_result__x-Ny8","categoryLink":"AutocompleteCategories_categoryLink__FLnFH"};